<template>
    <div class="bind-mobile-page" v-if="isShow">
        <div class="dialog-mask"></div>
        <div class="bind-content mask-content">
            <span class="close-icon" @click="close"></span>
            <div class="title">绑定手机号码</div>

            <div class="form-wrap">
                <div class="input">
                    <input ref="phoneInput" type="text" v-model="mobile" placeholder="请输入手机号" maxlength="11" oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')" />
                    <i class="error-tip" v-show="!isPhone">请输入11位手机号码</i>
                </div>
                <div class="input">
                    <input ref="codeInput" type="text" v-model="code" placeholder="请输入验证码" class="input-code" maxlength="6" @input="checkInputCode" @keyup="checkInputCode" @afterpaste="checkInputCode" />

                    <span :class="['get-code', isCountDown ? 'not-click' : '']" v-throttle="[getCode, 'click', 240]">
                        {{ isCountDown ? '倒计时' + formatTime(time) + 's' : '获取验证码' }}
                    </span>
                    <i class="error-tip" v-show="!isCode">请输入6位数字验证码</i>
                </div>
            </div>
            <div class="operate-btn-wrap">
                <template>
                    <span class="sp2" @click="bindMobileClick">
                        <i>确认</i>
                    </span>
                </template>
            </div>
        </div>
    </div>
</template>
<script>
import store from '@/store/store.js'
import { bindMobileSendCode, userBindMobile } from '@/http/api/user'

export default {
    name: 'BindMobileDialog',
    data() {
        return {
            isShow: false,
            mobile: '',
            code: '',
            isCountDown: false, // 是否在倒计时中
            time: 60, // 倒计时时间

            request: false
        }
    },
    computed: {
        isPhone: function() {
            if (this.mobile) {
                return this.mobile.length < 11 ? false : true
            } else {
                return true
            }
        },
        isCode: function() {
            if (this.code) {
                return this.code.length < 6 ? false : true
            } else {
                return true
            }
        },
        canClickLoginBtn: function() {
            return /^1[3-9]\d{9}$/.test(this.mobile) && /^\d{6}$/.test(this.code)
        }
    },
    watch: {
        isShow: function(value) {
            if (value) {
                let mobile = store.state.userInfo.mobile
                if (mobile) {
                    this.$cookies.set(mobile, 1, -1)
                }
                this.initData()
                this.request = false
                this.$nextTick(() => {
                    this.$Utils.setDialogZindex('bind-mobile-page')
                })
            } else {
                this.payload = ''
            }
        }
    },
    methods: {
        initData() {
            this.mobile = ''
            this.code = ''
            this.isCountDown = false
            this.time = 60
        },
        show() {
            this.isShow = true
        },
        replaceInput(e, key) {
            this[key] = this[key].replace(/[^0-9]/g, '')
        },
        cancelClick() {
            this.close()
        },
        bindMobileClick() {
            this.bindMobileRequest()
        },

        close() {
            this.isShow = false
        },

        checkInputCode(event) {
            let inputValue = this.code
            inputValue = inputValue.replace(/[^0-9]/g, '')
            if (inputValue.length > 6) {
                inputValue = inputValue.slice(0, 6)
            }
            this.code = inputValue

            if (event.key == 'Enter' || event.keyCode == 13 || event.code == 'Enter') {
                this.bindMobileRequest()
            }
        },
        // 绑定请求
        bindMobileRequest() {
            if (!this.canClickLoginBtn) {
                if (!this.mobile) {
                    return this.$Toast.show('手机号码不能为空')
                } else if (!/^1[3-9]\d{9}$/.test(this.mobile)) {
                    return this.$Toast.show('手机号码格式输入错误，请检查后重新输入')
                } else if (!/^\d{6}$/.test(this.code)) {
                    return this.$Toast.show('请输入六位数字验证码')
                }
                return false
            }
            var that = this
            userBindMobile({
                vCode: this.code
            }).then(function(res) {
                if (res.code == 200) {
                    that.$store.dispatch('userBasicInfoAction')
                    that.$Toast.show('绑定成功')
                    that.close()
                } else {
                    that.$Toast.show(res.msg)
                }
            })
        },

        getCode() {
            if (this.isCountDown) {
                return false
            } else if (!this.mobile) {
                return this.$Toast.show('手机号码不能为空')
            } else if (!/^1[3-9]\d{9}$/.test(this.mobile)) {
                return this.$Toast.show('手机号码格式输入错误，请检查后重新输入')
            } else {
                // 等滑块验证码背景图片完全加载出来才显示
                this.graphTimeid = setInterval(() => {
                    let img = $('.verify-img-panel img')
                    if (img) {
                        clearInterval(this.graphTimeid)
                        $('.verify-img-panel img').load(function() {
                            $(this).addClass('show')
                        })
                    }
                }, 100)

                sliderVerify(
                    'pop',
                    async res => {
                        if (res.token && res.captchaVerification) {
                            const data = {
                                mobile: this.mobile,
                                token: res.token,
                                captchaVerification: res.captchaVerification
                            }

                            bindMobileSendCode(data).then(res => {
                                if (res.code == 200 && this.$Utils.isObject(res.data)) {
                                    this.$refs.codeInput.focus()
                                    this.checkCodeSessionKey = res.data.checkCodeSessionKey
                                    this.isCountDown = true
                                    this.countDown()
                                } else {
                                    setTimeout(() => {
                                        this.$NormalDialog.show({
                                            title: '温馨提示',
                                            msg: res.msg
                                        })
                                    }, 1200)
                                }
                            })
                        }
                    },
                    {
                        appKey: '42645'
                    }
                )
            }
        },

        // 倒计时
        countDown() {
            clearTimeout(this.timeId)
            if (this.time > 0) {
                this.timeId = setTimeout(() => {
                    this.time--
                    this.countDown()
                }, 1000)
            } else {
                this.time = 60
                this.isCountDown = false
            }
        },
        // 倒计时补0
        formatTime(time) {
            if (time < 10) {
                return '0' + time
            } else {
                return time
            }
        }
    }
}
</script>
<style lang="less" scoped>
.bind-mobile-page {
    .bind-content {
        padding-top: 48px;
        width: 600px;
        height: 400px;
        background: url(../../../assets/dialog/login-bg.png) center/100% no-repeat;

        .title {
            color: @color-txt-high;
            font-size: 18px;
            text-align: center;
            margin-bottom: 24px;
        }

        .form-wrap {
            margin-top: 44px;
            margin-bottom: 16px;

            .input {
                position: relative;
                margin: 0 auto 24px;
                width: 360px;
                height: 40px;

                input {
                    width: 100%;
                    height: 100%;
                    line-height: 40px;
                    outline: none;
                    padding: 0 20px;
                    color: @color-txt-high;
                    border-radius: 20px;
                    border: none;
                    background: @bg-color-00;
                    font-size: @font-size-normal;

                    &::placeholder {
                        color: @color-txt-66;
                    }

                    &:focus {
                        background: url(../../../assets/input-bg.png) center/100% no-repeat;
                    }

                    &.input-code {
                        padding: 0 118px 0 24px;
                    }
                }

                .get-code {
                    position: absolute;
                    width: 118px;
                    height: 100%;
                    top: 0;
                    right: 0;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: @color-txt-normal;
                    font-size: @font-size-normal;
                    line-height: 22px;
                    cursor: pointer;
                    user-select: none;

                    &:hover {
                        color: @color-txt-high;
                    }

                    &.not-click {
                        cursor: not-allowed;
                    }
                }

                .error-tip {
                    position: absolute;
                    top: 41px;
                    left: 24px;
                    font-size: @font-size-small;
                    color: @color-number-yellow2;
                }
            }
        }

        .operate-btn-wrap {
            user-select: none;
            margin-top: 48px;
            .flex-center();

            span {
                .button-linear();
                width: 190px;
            }

            .sp1 {
                margin-right: 34px;
            }
        }
    }
}
</style>
